module.exports = __webpack_public_path__ + "static/media/img_product.5fbf3771.png";